<template>
  <div id="TargetSelectedForm" class="prompt-font">
    <div class="modal-card fixed-width">
      <!-- Modal Title -->
      <header class="modal-card-head">
        <p class="modal-card-title">SELECT YOUR TARGET</p>
      </header>
      <!-- Modal Description + Input -->
      <section class="modal-card-body">
        <div class="media">
          <div class="media-content">
            <div
              class="columns has-text-centered is-multiline is-tablet is-mobile"
            >
              <!-- Customer Registration -->
              <div class="column is-4-desktop is-4-tablet is-4-mobile">
                <article
                  @click="selectedTargetPressed('retire')"
                  class="tile is-child box card-hoveable"
                  :class="isRetirement ? 'selected-border' : ''"
                >
                  <img src="@/assets/factsheet_icons/target_retirement.svg" />
                  <p class="title is-5">แผนการเกษียณ</p>
                </article>
              </div>
              <!-- Customer Registration -->
              <div class="column is-4-desktop is-4-tablet is-4-mobile">
                <article
                  @click="selectedTargetPressed('education')"
                  class="tile is-child box card-hoveable"
                  :class="isEducation ? 'selected-border' : ''"
                >
                  <img src="@/assets/factsheet_icons/target_education.svg" />
                  <p class="title is-5">แผนการศึกษาบุตร</p>
                </article>
              </div>
              <!-- Customer Registration -->
              <div class="column is-4-desktop is-4-tablet is-4-mobile">
                <article
                  @click="selectedTargetPressed('tax')"
                  class="tile is-child box card-hoveable"
                  :class="isTax ? 'selected-border' : ''"
                >
                  <img src="@/assets/factsheet_icons/target_tax.svg" />
                  <p class="title is-5">วางแผนภาษี</p>
                </article>
              </div>
              <!-- Customer Registration -->
              <div class="column is-4-desktop is-4-tablet is-4-mobile">
                <article
                  @click="selectedTargetPressed('health')"
                  class="tile is-child box card-hoveable"
                  :class="isHealth ? 'selected-border' : ''"
                >
                  <img src="@/assets/factsheet_icons/target_protection.svg" />
                  <p class="title is-5">ประกันสุขภาพ</p>
                </article>
              </div>
              <!-- Customer Registration -->
              <div class="column is-4-desktop is-4-tablet is-4-mobile">
                <article
                  @click="selectedTargetPressed('family')"
                  class="tile is-child box card-hoveable"
                  :class="isProtect ? 'selected-border' : ''"
                >
                  <img src="@/assets/factsheet_icons/target_family.svg" />
                  <p class="title is-5">ทุนปกป้องครอบครัว</p>
                </article>
              </div>
              <!-- Customer Registration -->
              <div class="column is-4-desktop is-4-tablet is-4-mobile">
                <article
                  @click="selectedTargetPressed('invest')"
                  class="tile is-child box card-hoveable"
                  :class="isInvestment ? 'selected-border' : ''"
                >
                  <img src="@/assets/factsheet_icons/target_investment.svg" />
                  <p class="title is-5">การลงทุน</p>
                </article>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- Modal Footer -->
      <footer class="modal-card-foot" style="justify-content: flex-end;">
        <!-- Button: Save -->
        <button
          class="button is-primary"
          :disabled="disableSelectedPlan"
          @click="completedSelectTarget()"
        >
          Confirm
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "TargetSelectedForm",
  data() {
    return {
      isRetirement: false,
      isEducation: false,
      isTax: false,
      isHealth: false,
      isProtect: false,
      isInvestment: false,
      selectedTargets: []
    };
  },
  computed: {
    disableSelectedPlan: function() {
      if (this.selectedTargets.length > 0 && this.selectedTargets.length <= 4) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    completedSelectTarget: function() {
      let result = [];
      this.selectedTargets.forEach(target => {
        let title = "";
        let value = "";
        switch (target) {
          case "retire":
            title = "แผนการเกษียณ";
            value =
              "กำหนดเป้าหมาย และวิธีการลงทุน   เพื่อให้เพียงพอต่อเป้าหมายเกษียณ  หรือสร้างกองทุน เพื่อลูกหลานได้";
            break;
          case "education":
            title = "แผนการศึกษาบุตร";
            value =
              "เพื่อให้อนาคต   การศึกษาของลูก มีความมั่นคง และเป็นไปตาม แผนที่วางไว้ ในเวลาฉุกเฉิน";
            break;
          case "tax":
            title = "วางแผนภาษี";
            value =
              "บริหารจัดการภาษีเพื่อให้การลงทุน  จัดการความเสี่ยง ให้คุ้มค่าเต็มสิทธิ์ภาษี สอดคล้อง  กับสภาพคล่อง ที่มีในแต่ละช่วง";
            break;
          case "health":
            title = "ประกันสุขภาพ";
            value =
              "ลดความเสี่ยง โอนย้ายค่าใช้จ่าย  ค่ารักษาพยาบาล ตลอดจนชดเชย รายได้ในช่วงเวลา เจ็บป่วย";
            break;
          case "family":
            title = "ทุนปกป้องครอบครัว";
            value =
              "หนี้ถือเป็นมรดก สรุปข้อมูลและพบ ความสบายใจให้ คนข้างหลังด้วย การวางแผนค่า ความสามารถ เสาหลักครอบครัว";
            break;
          case "invest":
            title = "แผนการลงทุน";
            value =
              "ต่อยอดสินทรัพย์ ให้มีกระแสเงินสด โดยให้เงินทำงาน ด้วยวิธีการได้แก่ Asset Allocation, Market Timing";
            break;
          default:
            break;
        }
        result.push({ title, value, type: target });
      });
      this.$emit("selected", result);
      this.$emit("close");
    },
    selectedTargetPressed: function(target_key) {
      if (!this.selectedTargets.includes(target_key)) {
        this.selectedTargets.push(target_key);
        this.markSelectedOnCard(this.selectedTargets);
        this.unmarkSelectedOnCard(this.selectedTargets);
      } else {
        this.unmarkDuplicatedKeyOnCard(target_key, this.selectedTargets);
      }
    },
    markSelectedOnCard: function(selectedList) {
      selectedList.forEach(item => {
        switch (item) {
          case "retire":
            this.isRetirement = true;
            break;
          case "education":
            this.isEducation = true;
            break;
          case "tax":
            this.isTax = true;
            break;
          case "health":
            this.isHealth = true;
            break;
          case "family":
            this.isProtect = true;
            break;
          case "invest":
            this.isInvestment = true;
            break;
          default:
            break;
        }
      });
    },
    unmarkSelectedOnCard: function(selectedList) {
      if (selectedList.length > 4) {
        let remove_len = selectedList.length - 4;
        let removed = selectedList.splice(0, remove_len);
        removed.forEach(item => {
          switch (item) {
            case "retire":
              this.isRetirement = false;
              break;
            case "education":
              this.isEducation = false;
              break;
            case "tax":
              this.isTax = false;
              break;
            case "health":
              this.isHealth = false;
              break;
            case "family":
              this.isProtect = false;
              break;
            case "invest":
              this.isInvestment = false;
              break;
            default:
              break;
          }
        });
      }
    },
    unmarkDuplicatedKeyOnCard: function(key, selectedList) {
      const index = selectedList.findIndex(selected => selected === key);
      selectedList.splice(index, 1);
      switch (key) {
        case "retire":
          this.isRetirement = false;
          break;
        case "education":
          this.isEducation = false;
          break;
        case "tax":
          this.isTax = false;
          break;
        case "health":
          this.isHealth = false;
          break;
        case "family":
          this.isProtect = false;
          break;
        case "invest":
          this.isInvestment = false;
          break;
        default:
          break;
      }
    }
  }
};
</script>

<style scoped>
.card-hoveable {
  cursor: pointer;
  height: 100%;
}
.selected-border {
  border: 2px #20a6b7 solid;
}
.fixed-width {
  max-width: 580px;
  padding: 0 20px;
}
</style>
